export const GroupsRoute = {
  GroupDetail: 'group-detail',
  GroupDescription: 'group-description',
  GroupEditor: 'group-editor',
  GroupRequest: 'group-request',
  GroupRequests: 'group-requests',
  GroupMembers: 'group-members'
} as const;

export type GroupsRoute = (typeof GroupsRoute)[keyof typeof GroupsRoute];

export type GroupsParam = {
  [GroupsRoute.GroupDetail]: {
    groupId: string;
    name?: string;
    shortName?: string;
    memberCount?: number;
  };
  [GroupsRoute.GroupDescription]: { groupId: string };
  [GroupsRoute.GroupEditor]: { groupId: string } | undefined;
  [GroupsRoute.GroupRequest]: { groupId: string };
  [GroupsRoute.GroupRequests]: { groupId: string };
  [GroupsRoute.GroupMembers]: { groupId: string };
};
